// extracted by mini-css-extract-plugin
module.exports = {"install":"FuvmInstalling_install__1mjy9","install-title":"FuvmInstalling_install-title__1po6D"};